import {
  GET_SHOPPING_AREAS,
  GET_SHOPPING_AREAS_SUCCESS,
  API_ERROR,
  GET_SHOPPING_AREAS_V2,
  GET_SHOPPING_AREAS_V2_SUCCESS,
  GET_SHOPPING_AREAS_V2_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  shoppingAreas: [],
  shoppingAreasV2: [],
}

const ShoppingAreasList = (state = initialState, action) => {
  switch (action.type) {
    case GET_SHOPPING_AREAS:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_SHOPPING_AREAS_V2:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_SHOPPING_AREAS_SUCCESS:
      state = {
        ...state,
        shoppingAreas: action.payload.shoppingAreas,
        loading: false,
        done: true,
      }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false, done: true }
      break
    case GET_SHOPPING_AREAS_V2_SUCCESS:
      state = {
        ...state,
        shoppingAreasV2: action.payload.shoppingAreas,
        loading: false,
        done: true,
      }
      break
    case GET_SHOPPING_AREAS_V2_ERROR:
      state = { ...state, error: action.payload, loading: false, done: true }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default ShoppingAreasList
